import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import TRAUMA_Hindi from '../assets/TRAUMA_Hindi.jpg'
import TRAUMA_English from '../assets/TRAUMA_English.jpg'
import Footer from '../layout/Footer';

const TraumaCenterFacility = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (imageSrc) => {
        setSelectedImage(imageSrc);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-cyan-50">
            <Navbar />
            {/* Main Content */}
            <div className="container mx-auto px-4 py-12">
                {/* Language Selection Tabs */}
                <div className="flex justify-center mb-8">
                    <div className="bg-white rounded-lg shadow-lg p-2 inline-flex">
                        <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg font-semibold mr-2">
                            हिंदी
                        </div>
                        <div className="bg-green-100 text-green-800 px-4 py-2 rounded-lg font-semibold">
                            English
                        </div>
                    </div>
                </div>

                {/* Images Container */}
                <div className="flex flex-col lg:flex-row justify-center items-start gap-8 max-w-7xl mx-auto">
                    
                    {/* Hindi Document */}
                    <div className="w-full lg:w-1/2 group">
                        <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300">
                            {/* Header */}
                            <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-4">
                                <h3 className="text-xl font-bold text-center flex items-center justify-center gap-2">
                                    ट्रॉमा सेंटर में उपलब्ध महत्वपूर्ण सुविधाओं
                                </h3>
                            </div>
                            
                            {/* Image */}
                            <div className="relative overflow-hidden">
                                <img
                                    src={TRAUMA_Hindi}
                                    alt="Trauma Center Facilities in Hindi"
                                    className="w-full h-auto object-contain cursor-pointer hover:scale-105 transition-transform duration-300"
                                    onClick={() => openModal(TRAUMA_Hindi)}
                                />
                            </div>
                            
                            {/* Footer */}
                            <div className="p-4 bg-gray-50">
                                <p className="text-center text-gray-600 text-sm">
                                    📋 Complete facility information in Hindi language
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* English Document */}
                    <div className="w-full lg:w-1/2 group">
                        <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300">
                            {/* Header */}
                            <div className="bg-gradient-to-r from-green-600 to-green-700 text-white p-4">
                                <h3 className="text-xl font-bold text-center flex items-center justify-center gap-2">
                                     Important Facilities in Trauma Center
                                </h3>
                            </div>
                            
                            {/* Image */}
                            <div className="relative overflow-hidden">
                                <img
                                    src={TRAUMA_English}
                                    alt="Trauma Center Facilities in English"
                                    className="w-full h-auto object-contain cursor-pointer hover:scale-105 transition-transform duration-300"
                                    onClick={() => openModal(TRAUMA_English)}
                                />
                            </div>
                            
                            {/* Footer */}
                            <div className="p-4 bg-gray-50">
                                <p className="text-center text-gray-600 text-sm">
                                    📋 Complete facility information in English language
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal for Image Enlargement */}
            {selectedImage && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
                    onClick={closeModal}
                >
                    <div className="relative max-w-4xl max-h-full bg-white rounded-lg overflow-hidden">
                        <button
                            onClick={closeModal}
                            className="absolute top-4 right-4 bg-red-500 text-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-red-600 transition-colors z-10"
                        >
                            ✕
                        </button>
                        <img
                            src={selectedImage}
                            alt="Enlarged Trauma Facility"
                            className="w-full h-auto max-h-screen object-contain"
                        />
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default TraumaCenterFacility;